<template>
	<div class="opts_wrap" v-loading="loading">
		<div class="opts_line">
			<p class="txt">打印机：</p>
			<div class="con">
				<el-select class="w100" v-model="printer" placeholder="请选择" @change="changePrinter" clearable>
					<el-option v-for="item in printers" :key="item.name" :label="item.name" :value="item.name">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="opts_line">
			<p class="txt">快递网点：</p>
			<div class="con">
				<el-select class="w100" v-model="form.netsite_id" placeholder="请选择" @change="netsiteChange" clearable>
					<el-option v-for="item in netsites" :key="item.id" :label="item.netsite_name+'(余额'+item.amount+')'"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="opts_line">
			<p class="txt">发货地址：</p>
			<div class="con">
				<el-select class="w100" v-model="form.sender_address_idx" placeholder="请选择" clearable>
					<el-option v-for="(item,index) in sender_address" :key="item.id" :label="item.full_name" :value="index">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<el-input v-model="form.box_num" :disabled="listen_state" @input="boxNumChange" clearable>
					<p slot="prefix" class="label_title">发货框数：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<el-input v-model="form.bar_code_num" :disabled="handle_state" ref="autoInput" clearable>
					<p slot="prefix" class="label_title">标签条码：</p>
				</el-input>
			</div>
		</div>
		<div class="btn_wrap">
			<el-button :loading="listen_state" type="primary" @click="bindStart">
				<span v-if="!listen_state">开启监听</span>
				<span v-else>监听打单发货中...</span>
			</el-button>
			<el-button v-if="listen_state" @click="bindStop">停止监听</el-button>
			<!-- <p class="btn" @click="saveBtn()">生成面单</p> -->
			<el-button @click="cancel">关闭</el-button>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		mapActions,
		mapState,
		mapMutations
	} from "vuex";
	export default {
		name: "autoPrintDeliver",
		props: {
			isLoading: {
				type: Boolean,
				default: false
			},
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				
				form: {
					box_num: '',
					printer: '',
					netsite_id: '',
					sender_address_idx: '',
					bar_code_num: ''
				},
				netsites: [],
				listen_state: false,//监听状态
				handle_state: false,//处理打单发货状态
				sender_address: [],
				loading: false,
				printer: '',
				printers: [],
				socket: null,
				print_order_id: '',
			};
		},

		created() {},
		mounted() {
			this.init()
		},

		computed: {
			...mapState({

			}),
		},
		watch: {
			show(val) {
				if (val) {
					this.init()
				}else{
					this.bindStop()
				}
			}
		},

		methods: {
			...mapActions({
				getSupplierNetsite: "ucenter/getSupplierNetsite",
				opOrderAutoPrintDelivery: "ucenter/opOrderAutoPrintDelivery",
			}),
			init() {

				this.doConnect()
				let box_num = localStorage.getItem('box_num')
				box_num = box_num ? box_num : ''
				this.form = {
					box_num: box_num,
					printer: '',
					netsite_id: '',
					sender_address_idx: '',
					bar_code_num: '',
				}
				this.loading = true
				var param = {}
				this.getSupplierNetsite({
					data: param,
					success: (res) => {
						if (res.code === 200) {
							var list = res.data
							this.netsites = list
							for (var i in list) {
								var item = list[i]
								if (item.is_default) {
									this.form.netsite_id = item.id
									this.sender_address = item.sender_address
								}
							}
							if (this.sender_address.length > 0) {
								for (var j in this.sender_address) {
									var item = this.sender_address[j]
									if (item.is_default) {
										this.form.sender_address_idx = parseInt(j)
									}
								}
							}

							// this.form.netsite_id = res.data[0].id
							// this.sender_address = res.data[0].sender_address

						} else {
							this.$message({
								message: res.msg,
								type: 'error',
							});
						}
						this.loading = false
					}
				})
			},
			boxNumChange(e){
				localStorage.setItem('box_num',e)
			},
			netsiteChange(e) {
				let netsites = this.netsites
				let netsite = netsites.find(val => val.id == e)
				if (!netsite) {
					this.sender_address = []
					this.form.netsite_id = ''
					this.form.sender_address_idx = ''
					return
				}
				this.sender_address = netsite.sender_address
				this.form.sender_address_idx = ''
			},

			cancel() {
				this.$emit('close', {})
			},
			changePrinter(e) {
				this.doSetPrinterConfig(e)
			},
			bindStart() {
				if (this.listen_state) {
					return
				}
				if (this.printer === '') {
					this.$message.error('请选择打印机')
					return
				}
				if (this.form.netsite_id === '') {
					this.$message.error('请选择快递网点')
					return
				}
				if (this.form.sender_address_idx === '') {
					this.$message.error('请选择发货地址')
					return
				}
				if (this.form.box_num == ''||this.form.box_num<0) {
					this.$message.error('请属于发货框数量')
					return
				}
				console.log(this.form)
				this.listen_state = true
				this.$refs.autoInput.focus();
				this.startPrintDeliveryQueue()
			},
			bindStop() {
				this.listen_state = false
				this.handle_state = false
				// this.socket.close()
			},

			//获取待处理任务
			startPrintDeliveryQueue() {
				this.$refs.autoInput.focus();
				if (!this.listen_state) {
					return
				}
				var that = this
				var param = this.form
				console.log(this.form)
				if(that.handle_state||param.bar_code_num == ''){
					setTimeout(function(){
						that.startPrintDeliveryQueue()
					},2000)
					return
				}
				
				this.opOrderAutoPrintDelivery({
					data: param,
					success: (res) => {
						// console.log(res)
						if (res.code === 200) {
							that.handle_state = true
							if (res.data.step == 1){//多件订单未全部扫描完成时step=1
								this.$alert('多件包裹，发货框编号：'+res.data.box_number)
								this.form.bar_code_num = ''
								this.handle_state = false
								this.listen_state = true
								this.$refs.autoInput.focus();
								this.startPrintDeliveryQueue()
							}else if(res.data.step == 2){//单件订单或多件已扫描完成时step=2
								if(res.data.box_number){//多件订单扫描完成要显示货框编号
									this.$alert('商品已全部备齐,正在打单，发货框编号：'+res.data.box_number)
								}
								this.doPrint(res.data.print_data)
							}
						} else {
							
							if(res.data && res.data.box_number){
								this.$confirm(res.msg+', 是否继续扫描?', '发货框：'+res.data.box_number, {
									confirmButtonText: '继续扫描',
									cancelButtonText: '停止扫描',
									type: 'warning'
								}).then(() => {
									that.form.bar_code_num = ''
									setTimeout(function(){
										that.startPrintDeliveryQueue()
									},2000)
								}).catch(() => {
									that.bindStop()  
								})
							}else{
								this.$confirm(res.msg+', 是否继续扫描?', '提示', {
									confirmButtonText: '继续扫描',
									cancelButtonText: '停止扫描',
									type: 'warning'
								}).then(() => {
									that.form.bar_code_num = ''
									setTimeout(function(){
										that.startPrintDeliveryQueue()
									},2000)
								}).catch(() => {
									that.bindStop()  
								})
							}
							
						}
						
					}
				})
			},
			

			//打印相关
			//连接打印客户端
			doConnect() {
				let that = this
				that.socket = new WebSocket('ws://127.0.0.1:13888');
				// 打开Socket
				that.socket.onopen = function(event) {
					that.$message({
						message: '连接成功',
						type: 'success'
					})
					that.doGetPrinters()
				};
				// 监听消息
				that.socket.onmessage = function(event) {
					var data = JSON.parse(event.data)
					if (data.cmd == 'getPrinters') {
						console.log('获取打印机', data);
						that.printers = data.printers
						that.doSetPrinterConfig(data.printers[0].name)
						return;
					}
					if (data.cmd == 'setPrinterConfig') {
						// console.log('设置打印机',data,event)
						return;
					}
					if (data.cmd == 'print') {
						console.log('打印成功', that.print_order_id, data.taskID)
						that.$message.success('打印成功')
						setTimeout(function() {
							that.startPrintDeliveryQueue()
						}, 200)
						return;
					}
					if (data.cmd == 'getTaskStatus') {
						console.log('状态', data)
						return
					}

				};
				// 监听Socket的关闭
				that.socket.onclose = function(event) {
					that.$alert('连接失败，请检查抖店打单组件是否启动', '提示', {
						type: 'error',
						confirmButtonText: '确定',
						callback: action => {
							console.log(event)
							that.$emit('close', {})
						}
					});
					that.bindStop()
					that.socket = null
				};
			},

			//获取打印机信息
			doGetPrinters() {
				var request = {
					requestID: this.getNonceStr(),
					version: '1.0',
					cmd: 'getPrinters'
				};
				this.socket.send(JSON.stringify(request));
			},
			//设置打印机
			doSetPrinterConfig(name) {
				var request = {
					requestID: this.getNonceStr(),
					version: "1.0",
					cmd: "setPrinterConfig",
					printer: {
						name: name,
						needTopLogo: true,
						needBottomLogo: false
					}
				};
				this.printer = name
				this.form.printer = name
				console.log('绑定打印机：', this.printer)
				this.socket.send(JSON.stringify(request));
			},
			//打印
			doPrint(data) {
				console.log(data)
				this.print_order_id = data.order_id
				var request = {
					"cmd": "print",
					"requetID": this.getNonceStr(),
					"version": "1.0",
					"task": {
						"taskID": this.getNonceStr(),
						// "taskID": data.documentID,
						"preview": false,
						"printer": this.printer,
						"documents": [{
							"documentID": data.documentID,
							"contents": [{
									"templateURL": data.template_url1,
									"params": data.params_str,
									"signature": data.signature,
									"encryptedData": data.encryptedData,
									"addData": data.addData
								},
								{
									"templateURL": data.template_url,
									"data": data.data,
								}
							]
						}]
					}
				};
				this.socket.send(JSON.stringify(request));
			},
			//生成纯数字随机字符串
			getNonceStr(number = 10) {
				var arr = [];
				var arr1 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
				var nonceStr = ''
				for (var i = 0; i < number; i++) {
					var n = Math.floor(Math.random() * 10);
					arr[i] = arr1[n];
					nonceStr += arr1[n];
				}
				return new Date().getTime() + nonceStr
			},
		},

	}
</script>

<style scoped>
	.opts_wrap {
		padding-top: 14px;
	}

	.opts_wrap .opts_line {
		display: flex;
		align-items: center;
		position: relative;
		margin-bottom: 30px;
	}

	.opts_line .txt {
		width: 80px;
		text-align: left;
		font-size: 14px;
		position: absolute;
		left: 14px;
		z-index: 1;
		color: #C0C4CC;
	}

	.opts_line .con {
		flex: 1;
		width: 0;
		margin-left: 0px;
		display: flex;
		align-items: center;
	}

	.opts_line .con .t {
		font-size: 14px;
	}

	.opts_wrap .btn_wrap {
		margin: 40px auto 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.opts_wrap .btn_wrap .btn {
		width: 80px;
		height: 34px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		box-sizing: border-box;
		font-size: 14px;
	}

	.opts_wrap .btn_wrap .btn:nth-child(1) {
		background: var(--red);
		color: #fff;
		margin-right: 14px;
	}

	.opts_wrap .btn_wrap .btn:nth-child(2) {
		background: #fff;
		color: #333;
		border: 1px solid #ddd;
		margin-right: 14px;
	}

	.ml8 {
		margin-left: 8px;
	}

	.opts_wrap .btn_wrap .btn:nth-child(3) {
		background: #fff;
		color: #333;
		border: 1px solid #ddd;
	}

	.w80 {
		width: 80px;
	}

	.w100 {
		width: 100%;
	}

	.s_line {
		padding: 0 12px;
		height: 34px;
		line-height: 34px;
		border: 1px solid #DCDFE6;
		border-radius: 4px;
		width: 100%;
	}

	.s_line .label {
		color: #C0C4CC;
		font-size: 14px;
		width: 68px;
		display: inline-block;
	}

	.s_line .info {
		display: inline-block;
	}

	.el-input {
		height: 34px;
		line-height: 34px;
	}

	/deep/.el-input__prefix {
		height: 34px;
		line-height: 34px;
		margin-left: 15px;
		left: 0 !important;
	}

	/deep/.el-select .el-input__inner {
		padding-left: 80px;
		height: 34px;
		line-height: 34px;
	}

	/deep/.el-input--prefix .el-input__inner,
	.el-cascader .el-input .el-input__inner {
		padding-left: 80px;
		height: 34px !important;
	}
</style>